import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimInput]'
})
export class TrimInputDirective {
  @Input('appTrimInput') shouldTrim: boolean = true; // Default to true

  constructor(private ngControl: NgControl) {}

  @HostListener('blur', ['$event.target.value'])
  onBlur(value: string) {
    if (this.shouldTrim && this.ngControl.control) {
      const trimmedValue = value?.trim();
      this.ngControl.control.setValue(trimmedValue, {
        emitEvent: true,
      });
    }
  }
}
